module.exports = __webpack_public_path__ + "static/media/matthew.9cbf4a10.jpg";